class SubscriptionAccordion extends HTMLElement {
  constructor() {
    super();

    this.allRadioButtons = document.querySelectorAll('.c-sub-radio-buttons');
    this.allAccordions = document.querySelectorAll('subscription-accordion');

    this.radioButtons = this.querySelector('.c-sub-radio-buttons');

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (this.radioButtons) {
      this.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback() {
    if (this.radioButtons) {
      this.removeEventListener('click', this.handleClick);
    }
  }

  handleClick() {
    this.allAccordions.forEach(accordion => {
      accordion.removeAttribute('data-info');
    });

    this.setAttribute('data-info', 'active');

    this.allRadioButtons.forEach(radioButton => {
      radioButton.classList.remove('radio-buttons-visible');
    });

    this.radioButtons.classList.add('radio-buttons-visible');
  }
}

customElements.define('subscription-accordion', SubscriptionAccordion);